import jsPDF from "jspdf";
import "jspdf-autotable";
import { drawReportHeader } from "../../../../util/headerUtil";
import { themeColors } from "../../../../util/themeColors";

export const exportTPRChartPDF = (patientData, tprData, authCtx) => {
    const hospitalData = authCtx?.hospitalData;
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 10;

    // Standard HMS Header
    const startY = drawReportHeader(doc, hospitalData, "", {
        hideSeparator: true,
        isExport: false,
        margin: 10,
        top: 0
    });

    let currentY = startY + 5;

    // Patient Name and Date Info
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`PATIENT'S NAME: ${(patientData.name || "").toUpperCase()}`, margin, currentY);
    doc.text(`DATE: ${new Date().toLocaleDateString('en-IN')}`, pageWidth - margin, currentY, { align: "right" });
    currentY += 5;

    doc.text(`AGE / GENDER: ${patientData.age || "-"} / ${patientData.gender || "-"}`, margin, currentY);
    doc.text(`IPD NO: ${patientData.ipdAdmissionId || "-"}`, pageWidth - margin, currentY, { align: "right" });
    currentY += 10;

    // Grid Columns: TIME | P | BP | T | RR | AG | INPUT | OUTPUT | REMARKS
    const tableHead = [["DATE", "TIME", "P", "BP", "TEMP", "SPO2", "WT (kg)", "REMARKS"]];
    const tableBody = tprData.map(item => [
        item.date || "-",
        item.time || "-",
        item.pulse || "-",
        item.bpSystolic ? `${item.bpSystolic}/${item.bpDiastolic}` : "-",
        item.temp || "-",
        item.spo2 || "-",
        item.weight || "-",
        item.notes || "-"
    ]);

    // Fill up to 25 rows to look like a chart
    while (tableBody.length < 25) {
        tableBody.push(["", "", "", "", "", "", "", ""]);
    }

    doc.autoTable({
        startY: currentY,
        head: tableHead,
        body: tableBody,
        theme: 'grid',
        styles: {
            fontSize: 8,
            cellPadding: 2,
            lineColor: [212, 160, 23], // Golden/Yellowish border like image
            lineWidth: 0.2,
            textColor: [0, 0, 0],
            minCellHeight: 8
        },
        headStyles: {
            fillColor: [255, 242, 172], // Yellowish background like image
            textColor: [0, 0, 0],
            fontStyle: 'bold',
            halign: 'center'
        },
        columnStyles: {
            0: { cellWidth: 20, halign: 'center' },
            1: { cellWidth: 15, halign: 'center', fontStyle: 'bold' },
            2: { cellWidth: 12, halign: 'center' },
            3: { cellWidth: 22, halign: 'center' },
            4: { cellWidth: 15, halign: 'center' },
            5: { cellWidth: 15, halign: 'center' },
            6: { cellWidth: 15, halign: 'center' },
            7: { cellWidth: 'auto' }
        },
        margin: { left: margin, right: margin }
    });

    // Authority Sign at bottom right
    const finalY = doc.lastAutoTable.finalY + 30;
    const pageHeight = doc.internal.pageSize.getHeight();
    const signY = pageHeight - 20;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.line(pageWidth - margin - 50, signY, pageWidth - margin, signY);
    doc.text("Authority Sign / Doctor Sign", pageWidth - margin - 25, signY + 5, { align: "center" });

    const safeName = (patientData.name || "patient").replace(/[^a-z0-9]/gi, '_').toLowerCase();
    doc.save(`${safeName}_TPR_Chart.pdf`);
};
